module.exports = __webpack_public_path__ + "img/down-gz1.cab55588.jpg";